// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-virtual-table {\n  position: relative;\n}\n\n.v-virtual-table__wrapper {\n  display: flex;\n}\n\n.v-virtual-table__table {\n  width: 100%;\n  height: 100%;\n  overflow-x: auto;\n}", ""]);
// Exports
module.exports = exports;
